import { log } from '@/log'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ColorFamily, ColorFamilyList } from '@/models/tag/color-family'
import { getEnabledColorFamilyList } from '@/models/tag/color-family/filter-only-enabled'
import { TagsService } from '@spa/services/api/tags'
import { Either, left, right } from 'fp-ts/lib/Either'
import { identity } from 'fp-ts/lib/function'
import { compact } from 'lodash'

export interface ColorFamilyRepository {
  listOnlyEnabled(): Promise<Either<Error, ColorFamilyList>>
}

export class DefaultColorFamilyRepository implements ColorFamilyRepository {
  constructor(
    private readonly tagApiClient: TagsService,
    private readonly behavior: BehaviorConfig
  ) {}

  async listOnlyEnabled(): Promise<Either<Error, ColorFamilyList>> {
    return (await this.list()).fold(
      (e: Error) => left(e),
      (list: ColorFamilyList) => right(
        getEnabledColorFamilyList(list, this.behavior)
      )
    )
  }

  private async list(): Promise<Either<Error, ColorFamilyList>> {
    const response = await this.tagApiClient.get('mycolor.product.color_family')
    if (response.isLeft()) {
      return left(response.value)
    }

    const list = ColorFamilyList.valueOf(
      compact(response.value.map(tag => (
        ColorFamily.createFromDto(tag).fold(
          (error) => {
            log.warn({ error })

            return null
          },
          identity
        )
      )))
    )

    return right(list.sortAscByDisplayLevel())
  }
}
